import * as yup from 'yup';

export const validationSchema = yup.object({
  code: yup.string().required('Il campo è obbligatorio'),
  register: yup.string().required('Il campo è obbligatorio'),
  dateTo: yup.date().nullable().notRequired().typeError('Data non valida'),
  dateFrom: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .when('dateTo', (dateTo, formvalidationSchema) =>
      dateTo && dateTo?.toString() !== 'Invalid Date'
        ? formvalidationSchema.max(
            dateTo,
            'La data di Inizio validità deve essere minore uguale della data di Fine validità'
          )
        : formvalidationSchema.nullable()
    ),
  typePayment: yup.object().shape({
    secretariatCode: yup.string().required('Campo obbligatorio'),
    maritalStatusCode: yup.string().required('Campo obbligatorio'),
    fixedCode: yup.string().required('Campo obbligatorio'),
    expensesCode: yup.string().required('Campo obbligatorio'),
    stampCode: yup.string().required('Campo obbligatorio'),
  }),
});
